import { USER_LOGGED_IN, USER_LOGGED_OUT } from './types'
import api from 'api';
import { setAuthorisationHeader } from 'globals/utils'

export const userLoggedIn = (token) => ({
  type: USER_LOGGED_IN,
  token
})

export const userLoggedOut = () => ({
  type: USER_LOGGED_OUT
})

export const logout = (navto) => (dispatch) => {
  if (!!navto) {
    window.location.replace(navto)
  }
  sessionStorage.clear()
  dispatch(userLoggedOut())
  setAuthorisationHeader()
}

export const signup = (credentials) => (dispatch) => api.account.signup(credentials).then(data => { handleLogin(dispatch, data)})

export const handleLogin = (dispatch, data) => {
  if (!data) { 
    logout() 
  } else {
    const status = data.status
    const subscription = data.subscription
    const userName = data.userName
    const firstName = data.firstName
    const lastLogin = !!data.lastLogin && new Date(data.lastLogin)
    sessionStorage.setItem('status', status)
    sessionStorage.setItem('subscription', subscription)
    sessionStorage.setItem('firstName', firstName)
    sessionStorage.setItem('userName', userName)
    sessionStorage.setItem('lastLogin', lastLogin)

    let token = data.access_token
    if (!token) {
      if (!sessionStorage.token) throw new Error('No token in sessionStorage!')
      token = sessionStorage.token
    }
    sessionStorage.setItem('token', token)
    setAuthorisationHeader(token)
    dispatch(userLoggedIn({
      token,
      status,
      subscription,
      userName,
      lastLogin
    }))
  }
}

export const confirmEmail = (credentials) => (dispatch) =>
  api.account.confirmEmail(credentials).then(data => { handleLogin(dispatch, data)})

export const sendConfirmEmail = (data) => (dispatch) => api.account.sendConfirmEmail(data)

/* export const confirmPhone = (credentials) => (dispatch) =>
  api.account.confirmPhone(credentials).then(data => { handleLogin(dispatch, data)}) */

export const sendConfirmText = (data) => (dispatch) => api.account.sendConfirmText(data)

export const forgotPassword = (email) => (dispatch) => api.account.forgotPassword(email)

export const lostDevice = (data) => (dispatch) => api.account.lostDevice(data)

export const confirmLostDevice = (data) => (dispatch) => api.account.confirmLostDevice(data)

export const resetPassword = (data) => (dispatch) => api.account.resetPassword(data).then(data => { handleLogin(dispatch, data)})

export const acceptInvitation = (data) => (dispatch) => api.account.acceptInvitation(data).then(data => { handleLogin(dispatch, data)})

export const login = (credentials) => (dispatch) =>
  api.account.login(credentials).then(data => { handleLogin(dispatch, data)})

export const wizardComplete = (settings) => (dispatch) =>
  api.bmc.wizard.wizardComplete(settings).then(data => { handleLogin(dispatch, data)})
  
export const refreshStatus = () => (dispatch) => api.account.refreshStatus().then(data => { 
    if (!sessionStorage.token) throw new Error('No token in sessionStorage!')
    const token = sessionStorage.token
    const userName = sessionStorage.userName
    const status = data.status
    const subscription = data.subscription
    sessionStorage.setItem('status', status)
    sessionStorage.setItem('subscription', subscription)
    setAuthorisationHeader(token)
    dispatch(userLoggedIn({
      token,
      status,
      subscription,
      userName
    }))
    return subscription
  }).catch(err=>{
    console.log('err', err)
    this.setState({
      loading: false,        
      error: (err.response && err.response.data && err.response.data.Message) ? err.response.data.Message : 'Plan Activation Failed'
    })
  })

export const activatePlan = (code) => (dispatch) =>
  api.account.activatePlan(code).then(data => { 
    if (!sessionStorage.token) throw new Error('No token in sessionStorage!')
    const token = sessionStorage.token
    const userName = sessionStorage.userName
    const status = data.status
    const subscription = data.subscription
    sessionStorage.setItem('status', status)
    sessionStorage.setItem('subscription', subscription)
    setAuthorisationHeader(token)
    dispatch(userLoggedIn({
      token,
      status,
      subscription,
      userName
    }))
  })
